import { Component, inject } from '@angular/core';
import { GameService } from '@core/game/game.service';
import { LpMissionService } from '@features/lp/lp-mission/lp-mission.service';
import { LpVariablesService } from '@features/lp/lp-variables/lp-variables.service';
import { DebugInstanceComponent } from './debug-instance/debug-instance.component';
import { DebugVariablesComponent } from './debug-variables/debug-variables.component';

@Component({
  selector: 'app-game-debug',
  imports: [DebugVariablesComponent, DebugInstanceComponent],
  templateUrl: './game-debug.component.html',
  styleUrl: './game-debug.component.css',
})
export class GameDebugComponent {
  readonly _gameService = inject(GameService);
  readonly _lpMissionService = inject(LpMissionService);
  readonly _lpVariablesService = inject(LpVariablesService);
}
